import { useTranslation } from 'next-i18next';
import React, { FC } from 'react';
import { trackEvent } from 'src/common/3rdParty/tracking';
import Icon from 'src/common/components/IconDS22';
import ToggleDecorator from 'src/common/components/ToggleDecorator';
import { GA_EVENT_FILTER } from 'src/common/gaEvents';
import useStateDebounceChange from 'src/common/hooks/useStateDebounceChange';
import Typography from 'src/common/components/Typography';
import styles from './SuperOwnerFilter.module.scss';

export type SuperOwnerFilterProps = {
  value?: 'true' | null;
  onChange: (value: 'true' | null) => void;
};

const superownerOptionsMap = {
  yes: 'Superowner yes',
  no: 'Superowner no',
};

const GA_PARAM_SUPEROWNER = 'p7';

const SuperOwnerFilter: FC<SuperOwnerFilterProps> = ({ value: externalValue, onChange }) => {
  const [t] = useTranslation('search-page');
  const [value, setValue] = useStateDebounceChange((checked): void => {
    onChange(checked);
    trackEvent(GA_EVENT_FILTER, {
      [GA_PARAM_SUPEROWNER]: superownerOptionsMap[checked ? 'yes' : 'no'],
    });
  }, externalValue);
  return (
    <div className={styles.root}>
      <label className={styles.titleWrapper}>
        <Typography type="h3" weight="semibold" size="heading-5">
          {t('superowners-filter-title')}
        </Typography>
        <ToggleDecorator size="large">
          <input
            checked={!!value}
            type="checkbox"
            onChange={(event) => setValue(event.target.checked ? 'true' : null)}
          />
        </ToggleDecorator>
      </label>
      <div className={styles.description}>
        <Icon id="medal" size="l" className={styles.icon} />
        <Typography type="p" size="body-m">
          {t('superowners-filter-description')}
        </Typography>
      </div>
    </div>
  );
};

export default SuperOwnerFilter;
